import {DropdownModel} from '../../component/dropdown.model';
import {QuestionExtendedModel} from '../question-extended.model';

export class Translation2DModel extends QuestionExtendedModel {

  static TranslationTypes = {
    x: 'x',
    y: 'y',
    both: 'both',
    list: function() {
      return [this.x, this.y, this.both];
    },
    dropdownList: function () {

      const list = DropdownModel.generateFromKeys(this.list())

      return list;

    }
  };

  model = {
    translationType: 'both',
    gridSize: 5,
    numAnswers: 4
  };

  static generateModel(json: any): Translation2DModel {

    const q = new Translation2DModel();

    const model = json.model;

    if (model) {

      q.model.translationType = model.translationType;
      q.model.gridSize = model.gridSize;
      q.model.numAnswers = model.numAnswers;

    }

    return q;

  }

}
